import { IconAddonCell } from "@repo/design-system/components/grids";

export const withIconAddon = (renderer, col, columnEvents = {}) => (rowData) => {
    const content = renderer(rowData);
    if (!content) return content;

    const tooltipId = `tt-${col.field}-${rowData.id ?? ""}`;

    return (
        <div className="cell-wrapper">
            <IconAddonCell tooltipId={tooltipId} rowData={rowData} field={col.field}
                config={col?.config?.withIconWrapper} columnEvents={columnEvents}>
                {content}
            </IconAddonCell>
        </div>
    );
};